import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface NavigationArrowsProps {
  currentIndex: number;
  totalCards: number;
  onPrevious: () => void;
  onNext: () => void;
}
export function NavigationArrows({
  currentIndex,
  totalCards,
  onPrevious,
  onNext
}: NavigationArrowsProps) {
  return <div className="flex justify-center items-center gap-8 py-4" data-id="element-60">
      <button onClick={onPrevious} disabled={currentIndex === 0} className="p-3 rounded-full bg-blue-500 text-white disabled:bg-gray-300 disabled:cursor-not-allowed hover:bg-blue-600 transition-colors" aria-label="Previous question" data-id="element-61">
        <ChevronLeftIcon className="w-6 h-6" data-id="element-62" />
      </button>

      <span className="text-sm text-gray-600" data-id="element-63">
        {currentIndex + 1} / {totalCards}
      </span>

      <button onClick={onNext} disabled={currentIndex === totalCards - 1} className="p-3 rounded-full bg-blue-500 text-white disabled:bg-gray-300 disabled:cursor-not-allowed hover:bg-blue-600 transition-colors" aria-label="Next question" data-id="element-64">
        <ChevronRightIcon className="w-6 h-6" data-id="element-65" />
      </button>
    </div>;
}